/** Route rendered by the PredictionTrader single-page application. */
export type AppRoute =
  | { readonly kind: 'OVERVIEW' }
  | { readonly kind: 'STRATEGY'; readonly strategyKey: string }
  | { readonly kind: 'NOT_FOUND' };

/**
 * Builds the stable detail path for one strategy family.
 * @param strategyKey - Database-backed strategy key.
 * @returns URL path for the strategy detail page.
 */
export function strategyPath(strategyKey: string): string {
  return `/strategy/${encodeURIComponent(strategyKey)}`;
}

/**
 * Parses a browser pathname into the small application route model.
 * @param pathname - Current browser pathname.
 * @returns Overview, strategy detail, or not-found route.
 */
export function parseAppRoute(pathname: string): AppRoute {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (normalizedPath === '/' || normalizedPath === '/overview') return { kind: 'OVERVIEW' };
  const match = normalizedPath.match(/^\/strategy\/([^/]+)$/);
  if (match?.[1] === undefined) return { kind: 'NOT_FOUND' };
  try {
    const strategyKey = decodeURIComponent(match[1]);
    return strategyKey.length === 0 ? { kind: 'NOT_FOUND' } : { kind: 'STRATEGY', strategyKey };
  } catch {
    return { kind: 'NOT_FOUND' };
  }
}
